module.exports = __webpack_public_path__ + "static/assets/qr_bottom.ff2d4e74.png";